// extracted by mini-css-extract-plugin
export var animationContainer = "CtaWithAnimation-module--animationContainer--2b6b1";
export var animationWrapper = "CtaWithAnimation-module--animationWrapper--0ca64";
export var dark = "CtaWithAnimation-module--dark--13570";
export var fadeIn = "CtaWithAnimation-module--fadeIn--d6055";
export var fallback = "CtaWithAnimation-module--fallback--27e51";
export var lottie = "CtaWithAnimation-module--lottie--4bf39";
export var normal = "CtaWithAnimation-module--normal--fa47f";